import { useState } from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Avatar, Button, Card, Stack, styled, Text } from '@/theme/index';
import { PictureBookModal } from './PictureBookModal/PictureBookModal';

const StyledAvatar = styled(Avatar)`
  max-width: 80px;
  width: 100%;
  height: 100%;
`;

export const VehiclePictureBook = () => {
  const {
    data: { brandName },
    images: { vehiclePictureBookImg },
  } = useAppConstantsContext();

  const [isOpened, setIsOpened] = useState(false);

  const openPictureBookHandler = () => {
    setIsOpened(true);
  };

  const closePictureBookHandler = () => {
    setIsOpened(false);
  };

  return (
    <Card
      id="vehicle-story-book"
      variant="outlined"
      sx={{ boxShadow: 1, borderRadius: 0, p: 0, my: 2.5 }}
    >
      <Stack flexDirection="row">
        <StyledAvatar
          src={vehiclePictureBookImg}
          alt="Vehicle Storybook Roadmap Image"
          sx={{
            height: { xs: '40px', sm: '80px' },
            width: { xs: '40px', sm: '80px' },
          }}
          variant="square"
        />
        <Stack
          flexDirection={{ xs: 'column', md: 'row' }}
          p={1.5}
          justifyContent="space-between"
          flex={1}
        >
          <Stack flexDirection="column" mb={{ xs: 2, md: 0 }}>
            <Text variant="h4">
              {`How to use a ${
                brandName === 'Bumper' ? brandName : 'vehicle'
              } report.`}
            </Text>
            <Text variant="body1" color="text.secondary">
              A friendly beginner&apos;s guide to get started
            </Text>
          </Stack>
          <Button
            color="success"
            variant="contained"
            onClick={openPictureBookHandler}
          >
            Start Here
          </Button>
        </Stack>
      </Stack>
      {isOpened && (
        <PictureBookModal
          open={isOpened}
          handleCloseModal={closePictureBookHandler}
        />
      )}
    </Card>
  );
};
